<template>
    <div class="main-container">
      <inner-navigation class="grid-order-1" link="/crm/archived/potentials" title="Arşivlenmiş Fırsatlar" imgURL="archived-potentials.png" navStyle=1></inner-navigation>
      <inner-navigation class="grid-order-2" link="/crm/archived/tracked" title="Arşivlenmiş Takipler" imgURL="archived-targets.png" navStyle=1></inner-navigation>
      <inner-navigation class="grid-order-1" link="/crm/email-tags" title="Kontakt Etiketleri" imgURL="new-email.png" navStyle=1></inner-navigation>
      <inner-navigation class="grid-order-2" link="/crm/job-categories" title="İş Kategorileri" imgURL="category-types.png" navStyle=1></inner-navigation>
      <inner-navigation class="grid-order-3" link="/crm/milestones" title="Temas Türleri" imgURL="contact-types.png" navStyle=1></inner-navigation>
      <inner-navigation class="grid-order-1" link="/crm/email-list" title="Kontakt Listesi" imgURL="email-list.png" navStyle=1></inner-navigation>
      <inner-navigation class="grid-order-2" link="/crm/potentials/list" title="Fırsatlar" imgURL="potentials.png" navStyle=1></inner-navigation>
      <inner-navigation class="grid-order-3" link="/crm/tracked/list" title="Takip Listesi" imgURL="tracked.png" navStyle=1></inner-navigation>

    </div>
</template>

<script>

import InnerNavigation from "../InnerNavigation.vue"
import { mapGetters } from 'vuex'


export default {
  name: 'CRMHome',
  components: {
      InnerNavigation: InnerNavigation
  },
    computed: {
      ...mapGetters('user', {
          userProfile: 'userProfile',
      })
  },
}
</script>

<style scoped lang="scss">
  
  @import "../../styles/core/variables.scss";
  @import "../../styles/core/resets.scss";
  @import "../../styles/global/background.scss";
  @import "../../styles/global/helpers.scss";

</style>
